module.exports = __webpack_public_path__ + "img/aj-2.f4b4ca4d.png";